<template>
  <div
    class="quick-link-container"
    data-analytics-id="homepage-container"
    data-analytics-label="Quick Link"
  >
    <QuickLinks>
      <template v-for="(quickLink, index) in quickLinks">
        <QuickLink
          :key="quickLink.id"
          :open-in-new-tab="quickLink.openInNewTab"
          :text="quickLink.text"
          :url="quickLink.url"
          data-analytics-id="homepage-link"
          data-analytics-action="quicklink"
          :data-analytics-label="quickLink.url"
          @click="trackQuickLinkClicked(index, quickLink.text)"
        />
      </template>
    </QuickLinks>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QuickLink from '@sephora-asia/core-quick-link/QuickLink.vue'
import QuickLinks from '@sephora-asia/core-quick-links/QuickLinks.vue'
import impressionTracking from '@sephora-asia/common-ui/mixins/impressionTracking.js'

export default {
  name: 'QuickLinksContainer',

  components: {
    QuickLink,
    QuickLinks
  },

  mixins: [impressionTracking],

  computed: {
    ...mapGetters({
      quickLinks: 'quickLink/quickLinks'
    })
  },

  methods: {
    trackQuickLinkClicked(position, text) {
      const params = {
        quicklink_position: position + 1,
        quicklink_name: text
      }
      this.$analytics.trackEvent('homepage_click_quicklink', { params })
    },
    trackImpression() {
      this.quickLinks.map((quickLink, index) => {
        const params = {
          quicklink_position: index + 1,
          quicklink_name: quickLink.text
        }
        this.$analytics.trackEvent('homepage_impression_quicklink', { params })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-link-container {
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
